// import Splide from '@splidejs/splide';

export default {
  init() {

  
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js